import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=010efb7e&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=010efb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010efb7e",
  null
  
)

export default component.exports